import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=31fbf0a2&"
import script from "./Auth.vue?vue&type=script&lang=ts&"
export * from "./Auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fbf0a2')) {
      api.createRecord('31fbf0a2', component.options)
    } else {
      api.reload('31fbf0a2', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=31fbf0a2&", function () {
      api.rerender('31fbf0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Auth.vue"
export default component.exports